import { logError } from '../../error';
import { publish } from '../../message-bus';
import { MB_ADD_TO_SLIP } from '../../consts';
export const handleAddToSlip = ({ addToSlip, index, title }) => {
    try {
        const data = {
            id: addToSlip.selectionId,
            analytics: {
                BetListName: [`Banner`],
                BetListPosition: [`${index}`],
                FeatureDescription: title ? [`${title}`] : null,
            },
        };
        publish({ topic: MB_ADD_TO_SLIP, data });
    }
    catch (error) {
        const metadata = { ...addToSlip, index, title };
        logError({ error, metadata });
    }
};
